import { ArrowLeftRight } from 'lucide-react';
import { AppShell, MenuItem } from '@ui/components/layout/Shell';
import { CUSTOMER_APP_URL } from '@ui/lib/urls';
import { useMeQuery } from '@ui/store/authApi';
import { ADMIN_NAV } from './nav';

/** The admin panel's frame: the shared shell with the admin navigation. */
export function AdminShell() {
  const { data: session } = useMeQuery();
  return (
    <AppShell
      nav={ADMIN_NAV}
      badge="Admin"
      liveEventsPath="/api/admin/events"
      profilePath="/profile"
      menuItems={(close) =>
        (session?.organizations.length ?? 0) > 0 && (
          <MenuItem icon={ArrowLeftRight} onClick={() => { close(); window.location.assign(CUSTOMER_APP_URL); }}>
            My organization
          </MenuItem>
        )
      }
    />
  );
}
